import { makeAutoObservable } from "mobx";

export class CommandPaletteStore {
  isOpen = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }

  toggle(value?: boolean): void {
    this.isOpen = typeof value === "boolean" ? value : !this.isOpen;
  }
}
